<template>
  <Modal @close="localCloseModal" :wide="false" width="500px" :show-close="false">
    <h2>Din reservation har gått ut</h2>

    <p>Din reservation i varukorgen har gått ut. Andra gäster kan boka det som var reserverat av dig.</p>

    <p>Klicka nedan för att gå till varukorgen, där kan du prova att boka igen.</p>

    <div class="center">
      <button @click="goToCart()" class="small">Okej, gå till varukorgen</button>
    </div>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    ...mapMutations([
      'closeModal',
      'closeAllModals',
    ]),
    localCloseModal() {
    },
    goToCart() {
      this.closeAllModals();
      this.$router.replace({ name: 'shopping cart' });
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

h2
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  margin-bottom: 14px
</style>



// WEBPACK FOOTER //
// BookingCancelled.vue?6c1ba6dc